import ApiService from '../../api/ApiService';
import {DialogCallbacks} from '../../types/common';
import {dispatchAsync} from '../common';
import types from './types';
import api from '../../api';
import {DiplomatObjectTypeUnion} from 'types/DiplomatObjectType';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import {State} from 'redux/reducer';
import {ISynchronization} from 'types/diplomat/transaction/Synchronization';
/*


const release = (data: any) => action(types.RELEASE_SYNCHRONIZATION.SAGA, data);
const suspend = (data: any) => action(types.SUSPEND_SYNCHRONIZATION.SAGA, data);


const registerFormikProps = (key: SubPanelType, props: FormikProps<any>) =>
   action(types.REGISTER_FORMIK_PROPS, {key, props});

const resetForm = (packedId: string) => action(types.RESET_FORM, packedId);
const resetCurrentForm = () => action(types.RESET_CURRENT_FORM);

const validateSynchronization = () => action(types.VALIDATE_SYNCHRONIZATION.SAGA);
*/
const moveSynchronization = (
   synchronizationIds: string[],
   folderId: string,
   cbs?: DialogCallbacks
) =>
   dispatchAsync(api.synchronizationsMove, types.MOVE_SYNCHRONIZATION, {
      ...cbs,
      getMethod: ApiService.postSecureJson,
      data: {
         synchronizationIds,
         folderId,
      },
   });

const saveAs = (
   id: string,
   objectType: DiplomatObjectTypeUnion,
   name: string,
   options?: {
      onSuccess?: (data: ISynchronization) => void;
      onFailure?: (error: any) => void;
   }
) => async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => Promise<State>) => {
   // const state = await getState();
   // const currentObject = pageSelectors.getData(state);
   // let synchronization = currentObject;
   // if (id !== currentObject.id || objectType !== currentObject.objectType) {
   //    synchronization = await dispatch(
   //       dispatchAsync(`${api.synchronizations}/${id}`, types.GET_SYNCHRONIZATION)
   //    );
   // }

   // if (!synchronization) {
   //    console.error('Synchronization is null, "Clone" failed', id, objectType, name);
   // }

   return dispatch(
      dispatchAsync(api.synchronizationSaveAs, types.CREATE_SYNCHRONIZATION, {
         getMethod: ApiService.postSecureJson,
         data: {
            // existingSynchronization: synchronization,
            synchronizationId: id,
            newName: name,
            // overwrite: false,
         },
         onSuccess: options?.onSuccess,
         onError: options?.onFailure,
      })
   );
};

const actions = {
   // validateSynchronization,
   moveSynchronization,
   // release,
   // suspend,
   saveAs,
   // registerFormikProps,
   // resetForm,
   // resetCurrentForm,
   getRefsPgp: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.synchronizationsRefsPgp}/${id}`, types.GET_REFS_PGP, {
         ...cbs,
      }),
   getRefsSsh: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.synchronizationsRefsSsh}/${id}`, types.GET_REFS_SSH, {
         ...cbs,
      }),
   getRefsSsl: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.synchronizationsRefsSsl}/${id}`, types.GET_REFS_SSL, {
         ...cbs,
      }),
   getRefsProxy: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.synchronizationsRefsProxy}/${id}`, types.GET_REFS_PROXY, {
         ...cbs,
      }),
   getRefsPartner: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.synchronizationsRefsPartner}/${id}`, types.GET_REFS_PARTNER, {
         ...cbs,
      }),
   getRefsTransaction: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.synchronizationsRefsTransactions}/${id}`, types.GET_REFS_TRANSACTION, {
         ...cbs,
      }),
};

export default actions;
